import {
    LOADING_LIQUIDACIONES,
    LOADING_ORDENES_LIQUIDACION,
    LOADING_NOVEDADES_LIQUIDACION,
    FETCH_ACCIONES_LIQUIDACIONES,
    FETCH_ESTADOS_LIQUIDACIONES,
    FETCH_RESULTADOS_LIQUIDACIONES,
    FETCH_LIQUIDACIONES_BUSQUEDA,
    FETCH_LIQUIDACION_POR_ID,
    FETCH_LIQUIDACION_POR_ID_ORDENES,
    FETCH_LIQUIDACION_POR_ID_LOGISTICA,
    FETCH_LIQUIDACION_POR_ID_NOVEDADES,
    FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
    FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
    LOADING_LOGISTICA_LIQUIDACION,
    LIMPIAR_LIQUIDACIONES_BUSQUEDA
} from '../actions/types';

const initialState = {
    isLoadingLiquidaciones: false,
    isLoadingOrdenesLiquidacion: false,
    isLoadingNovedadesLiquidacion: false,
    isLoadingLogisticaLiquidacion: false,
    lista_acciones_liquidaciones: [],
    lista_estados_liquidaciones: [],
    lista_resultados_liquidaciones: [],
    lista_liquidaciones_busqueda: [],
    liquidacion_por_id: [],
    liquidacion_por_id_ordenes: [],
    liquidacion_por_id_logistica: [],
    liquidacion_por_id_novedades: [],
    ordenesLiquidacion: [],
    novedadesLiquidacion: [],
    filtro: {}
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        
        case LOADING_LIQUIDACIONES:
            return {
                ...state,
                isLoadingLiquidaciones: action.payload
            };

        case LOADING_ORDENES_LIQUIDACION:
            return {
                ...state,
                isLoadingOrdenesLiquidacion: action.payload
            };

        case LOADING_NOVEDADES_LIQUIDACION:
            return {
                ...state,
                isLoadingNovedadesLiquidacion: action.payload
            };

        case LOADING_LOGISTICA_LIQUIDACION:
            return {
                ...state,
                isLoadingLogisticaLiquidacion: action.payload
            };

        case FETCH_ACCIONES_LIQUIDACIONES:
            return {
                ...state,
                lista_acciones_liquidaciones: action.payload
            };

        case FETCH_ESTADOS_LIQUIDACIONES:
            return {
                ...state,
                lista_estados_liquidaciones: action.payload
            };

        case FETCH_RESULTADOS_LIQUIDACIONES:
            return {
                ...state,
                lista_resultados_liquidaciones: action.payload
            };

        case FETCH_LIQUIDACIONES_BUSQUEDA:
            return {
                ...state,
                lista_liquidaciones_busqueda: action.payload
            };

        case FETCH_LIQUIDACION_POR_ID:
            return {
                ...state,
                liquidacion_por_id: action.payload
            };

        case FETCH_LIQUIDACION_POR_ID_ORDENES:
            return {
                ...state,
                liquidacion_por_id_ordenes: action.payload
            };

        case FETCH_LIQUIDACION_POR_ID_NOVEDADES:
            return {
                ...state,
                liquidacion_por_id_novedades: action.payload
            };

        case FETCH_LIQUIDACION_POR_ID_LOGISTICA:
            return {
                ...state,
                liquidacion_por_id_logistica: action.payload
            };

        case FETCH_ORDENES_PARA_NUEVA_LIQUIDACION:
            return {
                ...state,
                ordenesLiquidacion: action.payload
            };

        case FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION:
            return {
                ...state,
                novedadesLiquidacion: action.payload
            };

        case LIMPIAR_LIQUIDACIONES_BUSQUEDA:
            return {
                ...state,
                lista_liquidaciones_busqueda: []
            };
            
        default: return state
    }
}

export default reducer;